import React from "react";
import classes from "./Boiler.module.css";

const Boiler = ({
  name,
  price,
  originalPrice,
  path,
  url,
  guarantee,
  centralHeatingOutput,
  width,
  height,
  depth,
  latestModel,
}) => {
  const img = require(`../../../icons/${path}.jpg`);
  let labelClasses = [classes.boilerContainer];
  if (!latestModel) {
    labelClasses.push(classes.boilerContainerNoLabel);
  }
  return (
    <div className={labelClasses.join(" ")}>
      <div className={classes.infoAndImageContainer}>
        <div className={classes.imageContainer}>
          <img className={classes.image} src={img} />
        </div>
        <div className={classes.infoContainer}>
          <div className={classes.nameGuaranteeContainer}>
            <span className={classes.name}>{name}</span>
            <div className={classes.guaranteeTagContainer}>
              <span className={classes.guarantee}>
                {guarantee} year guarantee
              </span>
              {latestModel && <span className={classes.tag}>Latest model</span>}
            </div>
          </div>
          <div className={classes.detailsContainer}>
            <div className={classes.detailContainer}>
              <span className={classes.detailText}>Central heating output</span>
              <div className={classes.detail}>
                <span className={classes.output}>{centralHeatingOutput}</span>
                <span className={classes.kilowatts}>kilowatts</span>
              </div>
            </div>
            <div className={classes.lineContainer}>
              <span className={classes.line}></span>
            </div>
            <div className={classes.detailContainer}>
              <span className={classes.dimensions}>Dimensions</span>
              <div>
                <span className={classes.dimensions}>
                  W {width}mm, D {depth}mm, H {height}mm
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.priceContainer}>
        <span className={classes.installationText}>
          Your fixed price including installation
        </span>
        <div>
          <div>
            <span className={classes.originalPrice}>£{originalPrice}</span>
            <span className={classes.slash}> / </span>
            <span className={classes.price}>£{price}</span>
          </div>
          <div className={classes.vat}>Including VAT</div>
        </div>
        <button
          onClick={() =>
            window.open(
              `https://www.sjwplumbing.co.uk/product/${url}`,
              "_blank",
              "noopener,noreferrer"
            )
          }
          className={classes.button}
        >
          Choose
        </button>
      </div>
    </div>
  );
};

export default Boiler;
